/*
 *
 * TeamTags actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import {
  CREATE_TEAM_TAGS,
  CREATE_TEAM_TAGS_ERROR,
  CREATE_TEAM_TAGS_SUCCESS,
  DELETE_TEAM_TAGS,
  DELETE_TEAM_TAGS_ERROR,
  DELETE_TEAM_TAGS_SUCCESS,
  GET_TEAM_TAGS_LIST,
  UPDATE_ACTION_STATUS,
  RESET_GET_TEAM_TAGS_LIST,
  UPDATE_TEAM_TAGS,
  UPDATE_TEAM_TAGS_ERROR,
  UPDATE_TEAM_TAGS_SUCCESS,
} from './constants';

export const getTeamTagsListAct = createAction(
  GET_TEAM_TAGS_LIST,
  (loadingState, params, data) => ({
    payload: {
      loadingState,
      params,
      data,
    },
  }),
);

export const resetGetTeamTagsList = createAction(RESET_GET_TEAM_TAGS_LIST);
export const deleteTeamTagsAct = createAction(DELETE_TEAM_TAGS);
export const deleteTeamTagsError = createAction(DELETE_TEAM_TAGS_ERROR);
export const deleteTeamTagsSuccess = createAction(DELETE_TEAM_TAGS_SUCCESS);
export const updateTeamTagsAct = createAction(UPDATE_TEAM_TAGS);
export const updateTeamTagsError = createAction(UPDATE_TEAM_TAGS_ERROR);
export const updateTeamTagsSuccess = createAction(UPDATE_TEAM_TAGS_SUCCESS);
export const createTeamTagsAct = createAction(CREATE_TEAM_TAGS);
export const createTeamTagsError = createAction(CREATE_TEAM_TAGS_ERROR);
export const createTeamTagsSuccess = createAction(CREATE_TEAM_TAGS_SUCCESS);
export const updateActionStatusAct = createAction(UPDATE_ACTION_STATUS);
